import React from 'react';
import Icon from 'components/AppIcon';

const OrderFilters = ({ filters, onFiltersChange, tradingPairs, orderTypes, activeTab }) => {
  const dateRangeOptions = [
    { value: 'all', label: 'All Time' },
    { value: '24h', label: 'Last 24 Hours' },
    { value: '7d', label: 'Last 7 Days' },
    { value: '30d', label: 'Last 30 Days' }
  ];

  const statusOptions = activeTab === 'open' 
    ? [
        { value: 'all', label: 'All Status' },
        { value: 'pending', label: 'Pending' },
        { value: 'partial', label: 'Partially Filled' },
        { value: 'executing', label: 'Executing' }
      ]
    : [
        { value: 'all', label: 'All Status' },
        { value: 'filled', label: 'Filled' },
        { value: 'cancelled', label: 'Cancelled' },
        { value: 'partially_filled', label: 'Partially Filled' }
      ];

  const handleFilterChange = (key, value) => {
    onFiltersChange(prev => ({
      ...prev,
      [key]: value
    }));
  };

  const clearFilters = () => {
    onFiltersChange({
      dateRange: 'all',
      tradingPair: 'all',
      orderType: 'all',
      status: 'all',
      searchQuery: ''
    });
  };

  const hasActiveFilters = Object.values(filters).some(value => value !== 'all' && value !== '');

  return (
    <div className="bg-surface rounded-trading border border-border p-6 mb-6 shadow-trading-card">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 flex-1">
          {/* Search */}
          <div className="relative">
            <Icon name="Search" size={16} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-text-secondary" />
            <input
              type="text"
              placeholder="Search orders..."
              value={filters.searchQuery}
              onChange={(e) => handleFilterChange('searchQuery', e.target.value)}
              className="w-full pl-10 pr-4 py-2 border border-border rounded-trading focus:outline-none focus:ring-2 focus:ring-primary-100 focus:border-primary text-sm"
            />
          </div>

          {/* Date Range */}
          <select
            value={filters.dateRange}
            onChange={(e) => handleFilterChange('dateRange', e.target.value)}
            className="px-3 py-2 border border-border rounded-trading focus:outline-none focus:ring-2 focus:ring-primary-100 focus:border-primary text-sm"
          >
            {dateRangeOptions.map(option => (
              <option key={option.value} value={option.value}>{option.label}</option>
            ))}
          </select>

          {/* Trading Pair */}
          <select
            value={filters.tradingPair}
            onChange={(e) => handleFilterChange('tradingPair', e.target.value)}
            className="px-3 py-2 border border-border rounded-trading focus:outline-none focus:ring-2 focus:ring-primary-100 focus:border-primary text-sm"
          >
            <option value="all">All Pairs</option>
            {tradingPairs.map(pair => (
              <option key={pair} value={pair}>{pair}</option>
            ))}
          </select>

          {/* Order Type */}
          <select
            value={filters.orderType}
            onChange={(e) => handleFilterChange('orderType', e.target.value)}
            className="px-3 py-2 border border-border rounded-trading focus:outline-none focus:ring-2 focus:ring-primary-100 focus:border-primary text-sm"
          >
            <option value="all">All Types</option>
            {orderTypes.map(type => (
              <option key={type} value={type}>
                {type.charAt(0).toUpperCase() + type.slice(1).replace('-', ' ')}
              </option>
            ))}
          </select>
        </div>

        <div className="flex items-center space-x-3">
          {/* Status Filter */}
          <select
            value={filters.status}
            onChange={(e) => handleFilterChange('status', e.target.value)}
            className="px-3 py-2 border border-border rounded-trading focus:outline-none focus:ring-2 focus:ring-primary-100 focus:border-primary text-sm"
          >
            {statusOptions.map(option => (
              <option key={option.value} value={option.value}>{option.label}</option>
            ))}
          </select>

          {/* Clear Filters */}
          {hasActiveFilters && (
            <button
              onClick={clearFilters}
              className="flex items-center space-x-2 px-3 py-2 text-text-secondary hover:text-text-primary transition-colors duration-trading-fast"
            >
              <Icon name="X" size={16} />
              <span className="text-sm font-body-medium">Clear</span>
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default OrderFilters;